module.exports = __webpack_public_path__ + "75bc7481b61e5cb306b0908d6010b76c.svg";